import React, {Component} from "react";
import Head from "../../components/Head";
import {withTranslate} from "react-redux-multilingual";
import globalMiddleware from "../../hocs/globalMiddleware";
import {setCurrentRoute} from "../../store/actions/globalActions";
import {connect} from "react-redux";


class Download extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);
    }


    state = {
        scroll: true,
    };


    render() {
        const history = [
            {
                page: this.props.translate("home"),
                to: "/"
            }
        ];


        return (
            <div id="download-page">

                {/*<Head title={this.props.translate("doctors")} history={history}/>*/}
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row text-center">
                                <img className="img-responsive apps-header-image"
                                     src="/images/multiple-devices.png" alt="device"/>
                                <div className="col-md-12 content-area">
                                    <h1 className="loon text-center">{this.props.translate("download_seena_app")}</h1>

                                    <div className="btn-wrapper text-center">
                                        <p className="text-center"> {this.props.translate("available_on_store")}
                                            <br/>
                                            {this.props.translate("free_download_desc")}
                                        </p>
                                        <div className="mt-20 mb-20">
                                            <a className="btn" target="_blank" rel="noopener noreferrer"
                                               href="https://itunes.apple.com/us/app/rklinic/id1437051698?mt=8"><img
                                                className="img-responsive store"
                                                src="https://assets.tvplayer.com/web/images/new-theme/appstore-md.png"
                                                alt="Download TVPlayer onto your iPhone, iPad or iPod Touch"/></a>
                                            <a className="btn" target="_blank" rel="noopener noreferrer"
                                               href="https://play.google.com/store/apps/details?id=com.rklinic"><img
                                                className="img-responsive store"
                                                src="https://assets.tvplayer.com/web/images/new-theme/google-play-md.png"
                                                alt="Download TVPlayer onto your Android mobile or tablet"/></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


}
const mapStateToProps = (state) => {
    return {
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(Download)));